// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anchor_like[data-v-7c1e9818]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
